import Marquee from "react-fast-marquee";
import { ArrowsLeftRight, Bank, ShieldCheck, Lightning, CurrencyCircleDollar, DeviceMobile } from "@phosphor-icons/react";

const ITEMS = [
  { icon: ArrowsLeftRight, label: "USDT → INR" },
  { icon: Lightning, label: "TRC20 Network" },
  { icon: Bank, label: "Direct Bank Payout" },
  { icon: ShieldCheck, label: "Secure Exchange" },
  { icon: CurrencyCircleDollar, label: "Transparent Rates" },
  { icon: DeviceMobile, label: "Android App" },
];

export default function Ticker() {
  return (
    <div className="marquee-fade border-y border-line/70 bg-pine/40 py-5" data-testid="ticker-marquee">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-3 text-sm font-medium uppercase tracking-[0.28em] text-mist">
            <item.icon size={18} weight="duotone" className="text-brand-400" />
            {item.label}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
